import { useCallback, useContext } from 'react';
import { css } from '@emotion/react';
import { FireworkBrand } from './FireworkBrand';
import { ModalContext } from './ModalContext';
/**
 *
 */
export const Menu = ({ children, promoUrl }) => {
    const props = useContext(ModalContext);
    const onClick = useCallback((e) => e.stopPropagation(), []);
    return (<>
      <div css={css `
          display: flex;
          flex-direction: column;
          justify-content: center;
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 320px;
          max-height: 95%;
          max-width: 95%;

          --background: var(--player-modal-background, var(--gray3));
          --color: var(--player-modal-font-color, var(--white));
        `} onClick={onClick} role="none">
        {children}
      </div>
      {props.branding ? <FireworkBrand url={promoUrl}/> : null}
    </>);
};
